import { Locale, type LocalizedString } from "../Locale.js";

export const openingQuoteMark: LocalizedString = {
	[Locale.cs]: "„",
	[Locale.en]: "“",
};
